'use es6';

import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { useDomains } from '../../../data/hooks/useDomains';
import { useControlsContext } from '../context';
import { getEventValue } from '../../../utils/jsEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const settingsUrl = `/settings/${PortalIdParser.get()}/domains/business-unit/view-all/`;
const StyledUISelect = styled(UISelect).withConfig({
  displayName: "EmailExternalRecipientSelect__StyledUISelect",
  componentId: "sc-5mibx4-0"
})([".Select-control .Select-arrow-zone > .Select-arrow{display:none;}"]);
const EmailExternalRecipientSelect = ({
  appUsageTracker
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const {
    formattedExternalRecipientSet,
    setExternalValidationError,
    setFormattedExternalRecipientSet,
    externalValidationError
  } = useControlsContext();
  const {
    data: externalDomains
  } = useDomains();
  const [externalRecipientSet, setExternalRecipientSet] = useState([]);
  const isValidExternalEmail = input => {
    return input.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi) && externalDomains.includes(input.split('@')[1]);
  };
  const getFieldValues = event => {
    const recipients = new Set(externalRecipientSet.map(recipient => recipient.value));
    recipients.add(event.target.value);
    return recipients;
  };
  const getRecipientSelections = emailSet => {
    const selections = [];
    emailSet.forEach(email => {
      selections.push({
        text: email,
        value: email,
        tagUse: isValidExternalEmail(email) ? '' : 'candy-apple'
      });
    });
    return selections;
  };
  const hasValidationError = emailSet => {
    for (const email of emailSet) {
      if (!isValidExternalEmail(email)) return true;
    }
    return false;
  };
  const onChangeExternalRecipientSet = event => {
    if (event.target.value === '') return;
    const newSelection = event.type === 'blur' ? getFieldValues(event) : new Set(getEventValue(event));
    setExternalRecipientSet(getRecipientSelections(newSelection));
    setExternalValidationError(hasValidationError(newSelection));
    setFormattedExternalRecipientSet(newSelection);
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailExternalRecipient.selectLabel"
    }),
    tooltip: externalDomains.length === 0 ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailExternalRecipient.knowledgebaseTooltip_jsx",
      elements: {
        Link: props => {
          return /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: "https://knowledge.hubspot.com/dashboard/email-or-export-reports-and-dashboards",
            onClick: () => {
              usageTracker.track(EVENTS.clickAccountSettingExternalEmailToolTipLink, {
                actionType: 'click',
                action: 'Navigate-to-learn-more-about-connecting-verified-domains',
                assetType: 'report'
              });
            },
            children: props.children
          });
        }
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailExternalRecipient.settingsTooltip_jsx",
      elements: {
        Link: props => {
          return /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: settingsUrl,
            onClick: () => {
              usageTracker.track(EVENTS.clickAccountSettingExternalEmailToolTipLink, {
                actionType: 'click',
                action: 'Navigate-to-account-settings-page',
                assetType: 'report'
              });
            },
            children: props.children
          });
        }
      }
    }),
    tooltipPlacement: 'right',
    error: externalValidationError,
    validationMessage: externalValidationError && /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailExternalRecipient.errorMessage_jsx",
      options: {
        settingsUrl
      },
      elements: {
        Link: UILink
      }
    }),
    children: /*#__PURE__*/_jsx(StyledUISelect, {
      anchorType: "combined",
      allowCreate: true,
      open: false,
      onBlur: onChangeExternalRecipientSet,
      onChange: onChangeExternalRecipientSet,
      options: externalRecipientSet,
      value: Array.from(formattedExternalRecipientSet),
      multi: true,
      placeholder: "",
      splitRegex: /,|;|\s/
    })
  });
};
export default EmailExternalRecipientSelect;